import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../auth/token.service';
import { HardwareConfigService } from '../hardware/hardware-config.service';

export const kioskGuard: CanActivateFn = async (route, state) => {
  const tokenService          = inject(TokenService);
  const router                = inject(Router);
  const hardwareConfigService = inject(HardwareConfigService);

  const mac = tokenService.mac;
  if (!mac) return false;

  // Garantit que le MAC est toujours présent dans les query params
  if (!route.queryParams['mac']) {
    const urlPath = state.url.split('?')[0];
    return router.createUrlTree([urlPath], {
      queryParams: { ...route.queryParams, mac },
    });
  }

  const token = await tokenService.ensureValidToken();
  if (!token) return false;

  await hardwareConfigService.load();
  return true;
};
